/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber, optional as codecOptional, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const SetSessionLockdownDataParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('set')],
    ['maxEntries', codecNumber, 'max_entries'],
    [
        'heartbeatEnforced',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'heartbeat_enforced',
    ],
]);
export class SetSessionLockdownData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SetSessionLockdownDataParser.decode(input).map(res => new SetSessionLockdownData(res));
    }
    static unsafeDecode(input) {
        return SetSessionLockdownData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SetSessionLockdownDataParser.encode(data);
    }
    static schema() {
        return SetSessionLockdownDataParser.schema();
    }
}
